import { useEffect } from 'react';

const OnboardingForms = () => {
  useEffect(() => {
    window.location.href = "https://na4.documents.adobe.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhD0GGgNvrho1nRmpun_nsrR5A3JULFpTuSagpWCRt1l8SAknKGUCGhZm1866JzxfL0*";
  }, []);

  return null;
};

export default OnboardingForms; 
